import React, { useEffect, useState } from "react";
import { InfoBanner, TableHeader } from "@services/ui-components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { OperationHistoryTable } from "../../../index";
import WarehouseJoyrideWrapper from "../../../Joyride/WarehouseTutorial/WarehouseJoyrideWrapper";
import {
    getCurrentStepFromLocalStorage,
    getWarehouseTutorialType,
    isWarehouseTutorialActive,
    setStepInLocalStorage,
} from "../../../Joyride/WarehouseTutorial/joyrideStepHelpers";
import { WarehouseTutorialType } from "../../../../utils/enums";
import StepScreenshotModal from "../../../Joyride/WarehouseTutorial/Modals/StepScreenshotModal";
import { saleProductsScreenshots } from "../../../Joyride/WarehouseTutorial/constants";

const OperationHistoryPage: React.FC = () => {
    const { t } = useTranslation();
    const { branchId, operationId, companyId } = useParams();
    const tutorialActive = isWarehouseTutorialActive();
    const tutorialType = getWarehouseTutorialType();
    const startStep = getCurrentStepFromLocalStorage();
    const [currentStep, setCurrentStep] = useState(() => getCurrentStepFromLocalStorage());
    const tutorialStepsWithScreens = [16, 17, 18, 19];
    const [showStepScreenshotModal, setShowStepScreenshotModal] = useState<boolean>(false);
    const handleCloseStepScreenshotModal = () => setShowStepScreenshotModal(false);

    useEffect(() => {
        if (tutorialStepsWithScreens.includes(startStep)) {
            setShowStepScreenshotModal(true);
        } else {
            setShowStepScreenshotModal(false);
        }
    }, [currentStep]);

    return (
        <div data-tour="history-operation">
            <InfoBanner>
                <p className="fs-7 mb-0">
                    {t("On this page, you can see who created and who edited the warehouse operation.")}
                </p>
            </InfoBanner>
            <div className="h-auto" data-tour="history-changes">
                <TableHeader
                    title={t("History of Changes")}
                    paths={[
                        { path: "", label: t("Warehouse accounting") },
                        { path: `/warehouses/branch/${branchId}`, label: t("Warehouses") },
                        { path: `/warehouses/operations/${branchId}`, label: t("Warehouse operations") },
                        {
                            path: `/warehouses/company/${companyId}/branch/${branchId}/warehouse-operations/${operationId}/change-history`,
                            label: t("History of Changes"),
                        },
                    ]}
                    colSize={9}
                    btnColSize={3}
                />
                <OperationHistoryTable />
            </div>

            {showStepScreenshotModal && tutorialType === WarehouseTutorialType.PRODUCT_SALES && (
                <StepScreenshotModal
                    key={currentStep}
                    show={showStepScreenshotModal}
                    onClose={handleCloseStepScreenshotModal}
                    step={currentStep}
                    screenshots={saleProductsScreenshots}
                    dialogClassName="screenshot"
                    centeredModal={false}
                    dataTour="screenshot-modal"
                />
            )}

            {tutorialActive && tutorialType && (
                <WarehouseJoyrideWrapper
                    tutorialType={tutorialType}
                    startStep={startStep}
                    goNext={() => {
                        const stepFromStorage = getCurrentStepFromLocalStorage();
                        setStepInLocalStorage(stepFromStorage);
                        setCurrentStep(stepFromStorage);
                        setShowStepScreenshotModal(true);
                    }}
                />
            )}
        </div>
    );
};

export default OperationHistoryPage;
